import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "rounded-borders" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Employee", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("First name")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Last name")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Roles")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Employee history log", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Employee activities log", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_audit_log_resource_history = _resolveComponent("audit-log-resource-history")!
  const _component_audit_log_operator_activities = _resolveComponent("audit-log-operator-activities")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_q_list, {
        class: "q-mb-lg",
        bordered: "",
        padding: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.employee?.firstName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.employee?.lastName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.employee?.email), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium self-start" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employee?.roles, (role, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(role.name), 1))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_8,
    (_ctx.history.length > 0)
      ? (_openBlock(), _createBlock(_component_audit_log_resource_history, {
          key: 0,
          history: _ctx.history
        }, null, 8, ["history"]))
      : _createCommentVNode("", true),
    _hoisted_9,
    (_ctx.activities.length > 0)
      ? (_openBlock(), _createBlock(_component_audit_log_operator_activities, {
          key: 1,
          activities: _ctx.activities
        }, null, 8, ["activities"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn, {
      to: { name: _ctx.EmployeeRouteNames.LIST, query: { page: _ctx.route.query.page }, params: { restoreFilters: 1 } },
      label: "Back to listing",
      color: "primary",
      "no-caps": "",
      outline: ""
    }, null, 8, ["to"])
  ]))
}